//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/NXObject.js";
let d=[[[0,"LongDescription",1,0],[0,"Override",1,"Routing.DesignRuleOverride",0],[0,"ShortDescription",1,0],[0,"TimeStamp",1,0]],[[["nObjects"],"GetObjects",{R_:{objects:"NXObject[]"}},0,0],[["objects"],"SetObjects",{},1,0],[["objects"],"AddObjects",{},1,0],[["user","reason","timestamp"],"SetViolationOverride",{},3,0],[[],"RemoveViolationOverride",{},0,0],[[],"IsRuleOverridden",{R_:{value:''}},0,0],[["deleteObject"],"DeleteRuleOverride",{},1,0],[["violationLocations"],"SetLocations",{},1,0],[["num_locations"],"GetLocations",{R_:{locationObjectList:"Routing.DesignRuleViolationLocation[]"}},0,0],[["locationObjects"],"AddViolationLocations",{},1,0],[["blank_option"],"BlankLocationObjectsOfViolation",{},1,0],[[],"GetOwningDesignRule",{R_:{owningDesignRule:"Routing.DesignRule"}},0,0]],[]];
SPLM.Routing.DesignRuleViolation = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.DesignRuleViolation";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.DesignRuleViolation.BlankOption = Object.freeze({
    "Blank" : "Blank", "Unblank" : "Unblank"});

export default SPLM;